export const calculatePercentage = (num: number, total: number): number => {
    return Math.round((num / total) * 100);
};
